export default __webpack_public_path__ + "static/media/no-parking.942deae9.png";